import React from 'react';

import { gql } from '@soundxyz/gql-string';

import { SongCardDropdownItems } from '@components/SongCards/shared/SongCardDropdown';
import { ThreeDotsDropdown } from '@components/basics/Dropdowns/ThreeDotsDropdown';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment } from '@graphql/reactQuery';
import { ChartsThreeDotReleaseInfoFragmentDoc } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ChartsThreeDotReleaseInfo on Release {
    id
    webappUri
    type
    track {
      id
    }
    ...SongCardDropdownInfo
  }
`);

export function ChartCardThreeDotMenu({
  release,
}: {
  release: FragmentType<ChartsThreeDotReleaseInfoFragmentDoc>;
}) {
  const [isDropdownOpen, setIsDropdownOpen] = React.useState<boolean>(false);

  const releaseInfo = getFragment(ChartsThreeDotReleaseInfoFragmentDoc, release);

  return (
    <ThreeDotsDropdown
      setIsDropdownOpen={setIsDropdownOpen}
      isDropdownOpen={isDropdownOpen}
      dropdownProps={{
        align: 'end',
        queue: true,
      }}
    >
      <SongCardDropdownItems release={releaseInfo} isNonArtistOwner={false} showLikeSound={false} />
    </ThreeDotsDropdown>
  );
}
